import { GET_LOGIN_HISTORY, GET_LOGIN_HISTORY_ERROR, GET_LOGIN_HISTORY_REQUEST, UPDATE_LOGIN_HISTORY_DATA, REMOVE_LOGIN_HISTORY } from "../ActionTypes/ActionTypes.js";

const initialState = {
    loginHistoryLoading: false,
    loginHistoryData: null,
    loginHistoryError: null,
    loginHistoryStatus: null,
    isModified: false,
    isFirstLoad: true,


};

const loginHistoryReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_LOGIN_HISTORY_REQUEST:
            return { ...state, loginHistoryLoading: true, loginHistoryStatus: null, loginHistoryData: null };
        case GET_LOGIN_HISTORY:
            return {
                loginHistoryLoading: false, loginHistoryData: action.payload, loginHistoryError: null, loginHistoryStatus: true,

                isFirstLoad: false,
            };

        case GET_LOGIN_HISTORY_ERROR:
            return { loginHistoryLoading: false, loginHistoryData: null, loginHistoryError: action?.payload, loginHistoryStatus: false, isFirstLoad: false, };
        case UPDATE_LOGIN_HISTORY_DATA:
            return {
                ...state,
                loginHistoryData: {
                    ...state.loginHistoryData,
                    result: {
                        ...state.loginHistoryData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_LOGIN_HISTORY:
            return { ...state, loginHistoryData: null, loginHistoryError: null, isModified: false, loginHistoryStatus: null, isFirstLoad: true, loginHistoryLoading: false }
        default:
            return state;
    }
};

export default loginHistoryReducer;